import { AdvancedImage } from '@cloudinary/react'
import { Cloudinary } from '@cloudinary/url-gen'
import { thumbnail } from '@cloudinary/url-gen/actions/resize'

// Create and configure your Cloudinary instance.
const cloudinary = new Cloudinary({
	cloud: {
		cloudName: process.env.CLOUDINARY_CLOUD_NAME,
	},
})

export function CloudinaryImage({
	id,
	width = 160,
	height = 90,
}: {
	id: string
	width?: number
	height?: number
}) {
	const image = cloudinary.image(id)

	image.resize(thumbnail().width(width).height(height))

	return <AdvancedImage cldImg={image} />
}
